var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"loader",class:_vm.loading && 'active'},[_c('img',{attrs:{"src":"/img/loader.svg","alt":""}})]),(_vm.reciept_link)?_c('iframe',{attrs:{"src":_vm.reciept_link}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }